import { Stack, Typography } from "@mui/material";
import React from "react";
import GenerateAudioButton from "./GenerateAudioButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { colors } from "colors";
import { useTheme } from "@emotion/react";

export default function MessageControls({ message, inContext, processing }) {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row">
        <GenerateAudioButton message={message} processing={processing} />
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={0.5}
      >
        <CheckCircleIcon
          color="text"
          sx={{
            width: "10px",
            opacity: !processing && inContext ? 1 : 0,
          }}
        />
        {!message.streaming && (
          <Typography
            variant="caption"
            fontFamily="Anton"
            fontSize="8px"
            sx={{
              opacity: !processing && inContext ? 1 : 0,
              color: theme.palette.text.main,
            }}
          >
            In context
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
